/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useSelector } from 'react-redux';
import useAuth from 'services/custom-hooks/useAuth';
import useCheckScreenExists from 'services/custom-hooks/useCheckScreenExists';
import PageNotAuthorizedContainer from 'views/pages/403';
import { getScreenPermissions, getScreenResolveType } from 'domain/utils';
import {
  ADEBIFY_ALL_SCREEN_IDS,
  MMM_ALL_SCREEN_IDS,
} from 'services/routes/constants';
import { mmmManagePermissions } from 'domain/permissions/screenPermissionConfigs';
import {
  selectAdebifyAccessible,
  selectAdebifyChecked,
} from 'store/adebify/selectors';

const withAuth = (
  Component,
  { currentTab, screenId, onRedirect = () => <PageNotAuthorizedContainer /> }
) => {
  return function WithAuth(props) {
    const { isExistsScreen } = useCheckScreenExists();

    let { isAllowed } = useAuth(
      getScreenPermissions(screenId, currentTab),
      getScreenResolveType(screenId)
    );

    let component = isExistsScreen ? onRedirect() : <></>;

    const hasManageMmm = useAuth(mmmManagePermissions).isAllowed;
    const isAdebifyAccessible = useSelector(selectAdebifyAccessible);
    const isAdebifyChecked = useSelector(selectAdebifyChecked);

    // MMM: user permission (manage/mmm:edit). Contract is implied by auth_api when edit is present.
    if (MMM_ALL_SCREEN_IDS.includes(screenId) && !hasManageMmm) {
      isAllowed = false;
    }

    if (ADEBIFY_ALL_SCREEN_IDS.includes(screenId)) {
      if (!isAdebifyChecked) {
        isAllowed = false;
        component = <></>;
      } else if (!isAdebifyAccessible) {
        isAllowed = false;
      }
    }

    return isAllowed ? <Component {...props} /> : component;
  };
};

/**
 * Since the former HoC withAuth just somehow doesn't work with Route and params (invalid hooks called ...)
 * This HoC is created to simply work with other cases
 * @param currentTab
 * @param screenId
 * @param onRedirect
 */
export const withAuthHoC = ({
  currentTab,
  screenId,
  onRedirect = () => <PageNotAuthorizedContainer />,
}) => (WrappedComponent) => {
  const { isAllowed } = useAuth(
    getScreenPermissions(screenId, currentTab),
    getScreenResolveType(screenId)
  );

  if (!isAllowed) {
    return onRedirect();
  }

  return WrappedComponent;
};

export default withAuth;
